import _ from 'lodash';
import React from 'react';
import { CarouselDesktop, Margin, Padding, Text } from '../../components';
import {
  LifeAtGlossierComponent,
  lifeAtGlossierData,
  lifeAtGlossierImages,
} from './shared';

export const LifeAtGlossierDesktop = () => {
  return (
    <Margin size={[7, 0, 7, 0]}>
      <CarouselDesktop images={lifeAtGlossierImages}>
        {_.flow((lifeAtGlossierData) =>
          _.map(lifeAtGlossierData, (value, index) => {
            return (
              <div key={index}>
                <Padding size={[6, 4]}>
                  <Text align="left" textType="heading3">
                    Life at Glossier
                  </Text>
                </Padding>
                <LifeAtGlossierComponent value={value} />
              </div>
            );
          })
        )(lifeAtGlossierData)}
      </CarouselDesktop>
    </Margin>
  );
};
